import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  extractCalculateTarrifType,
  filterTariffsByType,
} from '../../api/Requests';
import axios from 'axios';
import { RootState } from '..';
import { getTariffAdditionalBody } from 'src/utils';
import {
  getBlacklistedTariffs,
  getDefaultTariffTypes,
  stripDisabledTariffTypes,
} from 'src/utils/constants';

export const getInsurer = createAsyncThunk(
  'deeplink/insurances/additional',
  async (_, thunkAPI: any) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const insuraceType = await axios.get(
        process.env.REACT_APP_BASE_URL +
          `/${state.config.mandant}/calculate/insurances/additional`
      );
      if (insuraceType?.data?.value) {
        return insuraceType?.data?.value.map((insurer: any) => {
          return { id: insurer.insuranceId, value: insurer.insuranceName };
        });
      }
      return insuraceType?.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
);

export const getTariffs = createAsyncThunk(
  'deeplink/tariffs/additional',
  async ({ insurer, tarifftypes, employeeInsurance }: any, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const requestedTypes = stripDisabledTariffTypes(
        (tarifftypes
          ? tarifftypes
          : getDefaultTariffTypes(state.config.mandant).join(',')
        ).split(',')
      );
      const obje = extractCalculateTarrifType(
        requestedTypes.join(','),
        state.contribution.homecareLevel5Inpatient,
        state.contribution.daySicknessDailyAllowance1,
        state.contribution.rateSicknessDailyAllowance1
      );
      const promises = obje.map((obj) =>
        axios.post(
          process.env.REACT_APP_BASE_URL +
            `/${state.config.mandant}/calculate/tariffs/additional`,
          {
            responseDescription: 'true',
            startDate: '2023-08-01',
            customer: {
              birthday: '1980-06-02',
              gender: 'MALE',
              maritalStatus: '1',
              occupationGroup: '1',
            },
            additional: getTariffAdditionalBody(
              obj,
              state.config.mandant,
              employeeInsurance
            ),
          }
        )
      );
      const response = await Promise.all(promises);
      let resObj: any = [];
      const blacklistedTariffs = getBlacklistedTariffs(state.config.mandant);

      response.forEach((item, index) => {
        resObj = [
          ...resObj,
          ...filterTariffsByType(
            requestedTypes[index],
            item.data.value as any[],
            (tariff: any) => tariff.id
          ),
        ];
      });

      resObj = resObj.filter((item: any) => {
        return insurer.includes(item.insuranceId);
      });

      if (blacklistedTariffs.length) {
        resObj = resObj.filter((item: any) => {
          return !blacklistedTariffs.includes(item.id);
        });
      }

      const finalResponse = resObj.map((item: any) => {
        return {
          id: item.id,
          value: item.displayString,
        };
      });
      return finalResponse;
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
);
